import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../../core/middleware-call/login.service';
import { Router, ActivatedRoute } from '@angular/router';
import { HeaderSharingService } from '../../../core/services/header-sharing.service';
import { Promise, reject } from 'q';

@Component({
  selector: 'app-internal-server-error',
  templateUrl: './internal-server-error.component.html',
  styleUrls: ['./internal-server-error.component.scss']
})
export class InternalServerErrorComponent implements OnInit {

  constructor(
    private loginService: LoginService,
    private headerSharingService: HeaderSharingService,
    public router: Router,
    public route: ActivatedRoute
  ) { }

  ngOnInit() {
    //check if the error is due to invalid token...
    //this.isTokenValid(); // Migrated to error-handling.service.ts
  }

/*
  isTokenValid() {
    console.log("running isTokenValid");

    this.loginService.isTokenValid().subscribe(
      result => {
        console.log(result);
        if (result == true) {
          //console.log("Something went wrong but the user token is still valid");
        }
        else {
          this.headerSharingService.role.next(null);
          this.headerSharingService.isUserLoggedIn.next(false);
          // MAke sure to log off so the session of this token gets destroyed
            // Then Forward the user to a session expired page : prompting him to login again
          this.headerSharingService.logOff().then(res => {
            this.router.navigate(['/public/sessionExpired']);
          });
        };
      },
      error => {
        console.log(error);
        if (error.ok == true)
          console.log("############### Token still Valid"); // stay on error page because something else went wrong (prompt admin message)
        else //if (error.ok == "false")
        {
          console.log("############### Token NOT Valid"); // session has expired - send to page that prompts login

          this.router.navigate(['/sessionExpired']);
        }
      }
    )
  }
*/

  

}
